import { useRef, useEffect } from "react";

const StatusDropdown = ({ visible, options, onSelect, onClose, style }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div
      ref={popupRef}
      className="w-[250px] bg-white border border-gray-300 rounded-md p-2 absolute z-10"
      style={style}
    >
      <div className="w-full max-h-[150px] overflow-y-auto">
        {options.map((status) => (
          <div
            key={status}
            onClick={() => onSelect(status)}
            className="px-2 py-2 cursor-pointer rounded-lg hover:bg-themeColor hover:text-white text-gray-700 text-sm"
          >
            {status}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusDropdown;